module.exports = __webpack_public_path__ + "static/img/hanhwa-chemical.274a616.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/hanhwa-chemical.jpg
// module id = rYGg
// module chunks = 0